import { db, bucket, auth } from "../../firebase/config.js"
import firebase from '../../firebase/compat'
import { useHistory } from "react-router-dom";
import { useState, useContext } from 'react';
import { Auth } from '../../StateManagment/Auth';
import ScrollToTop from "../../hooks/ScrollToTop";
import DeleteModal from "../../components/common/DeleteModal";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import buildUploadPath from '../../helpers/uploads/buildUploadPath';
import TwoFactorSettings from '../../components/auth/TwoFactorSettings';

const Profile = () => {
    // Context
    const [ authO ] = useContext(Auth)

    // State
    const [deleteModal, setDeleteModal] = useState(false)

    // Hooks
    const history = useHistory()
    ScrollToTop()

    // Change profile photo
    const changePhoto = (e) => {

        const newPhoto = e.target.files[0]

        // Uniek pad: een ruwe bestandsnaam laat twee mensen met dezelfde
        // 'foto.jpg' elkaars afbeelding overschrijven.
        // AI-CONTEXT: See docs/inbox.md #122
        const storageRef = bucket.ref(buildUploadPath(newPhoto.name, "ProfilePhotos"));
        const uploadTask = storageRef.put(newPhoto)

        uploadTask.then(() => {
          
            uploadTask.on('state_changed', snapshot => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED:
                console.log('Upload is paused');
                break;
            case firebase.storage.TaskState.RUNNING:
                console.log('Upload is running');
                break;
            }
            }, (err) => {
                alert(err)
            }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            console.log('File available at', downloadURL);

            savePhoto(downloadURL)

                })
            })
        }).catch((err) => {
            // Zonder deze afhandeling verdwijnt een geweigerde upload (te groot,
            // of tegengehouden door storage.rules) in een niet-afgevangen
            // belofte: geen melding, en de gebruiker ziet niets gebeuren.
            alert(`Uploaden mislukt: ${err?.message || err}`)
        })
    }

    // Save photo to database
    const savePhoto = (photo) => {
        auth.onAuthStateChanged(User =>{
            if(User){
                db.collection("Users")
                .doc(User.uid)
                .update({
                    Photo: photo
                })
            }
        })
    }

    // Delete account — wordt vanuit het bevestigingsvenster aangeroepen, dus
    // niet meer vanaf een knop-event: ButtonClicked zou hier op undefined
    // stuklopen.
    const deleteAccount = () => {
        
        db.collection("Users")
        .doc(authO.Docid)
        .update({
            Deleted: true
        })
        .then(() => {
            auth
            .currentUser
            .delete()

            console.log('Account verwijderd')
        })
        .then(() => {
            history.push(`/`)
            window.location.reload()
        }) 
        .catch(err => {
            console.log(err)
        })

        console.log('Account in database geupdate')

    }

    // Change first name
    const forNameHandler = (e) => {
        const forName = e.target.value

        db.collection("Users")
        .doc(authO.Docid)
        .update({
            ForName: forName,
        })
    }

    // Change last name
    const surNameHandler = (e) => {
        const surName = e.target.value

        db.collection("Users")
        .doc(authO.Docid)
        .update({
            SurName: surName,
        })
    }

      // Log out
    const logOut = () => {
        auth.signOut()
        .then(() => {
            history.push(`/home`)
            window.location.reload()
        }) 
    }

    return (
        <div className="main">
                <div className="main-container">
                    <div className='page-header'>
                        <h1>Mijn profiel</h1>
                    </div>

                    <div className="table-container dashboard-container">
                        <h2>Schermnaam</h2>
                        <h5>Voornaam</h5>
                        <input className="input-classic" type="text" defaultValue={authO?.ForName} onChange={forNameHandler}/>
                        <h5>Achternaam</h5>
                        <input className="input-classic" type="text" defaultValue={authO?.SurName} onChange={surNameHandler}/>
                    </div>

                    <div className="table-container dashboard-container">
                        <h2>Profielfoto</h2>
                        <div className="photo-container-profile">
                            <img id="adjust-photo-profile" src={authO?.Photo} alt="" />
                        </div>
                        <input className="input-classic" type="file" onChange={changePhoto} />
                    </div>

                    <TwoFactorSettings />

                    <div className="table-container dashboard-container">
                        <h2>Uitloggen</h2>
                        <button onClick={logOut}>Uitloggen</button>
                    </div>

                    <div className="table-container dashboard-container">
                        <h2>Account verwijderen</h2>
                        <p>Let op! Als je je account verwijderd, kan je deze niet meer herstellen.</p>
                        <button id="delete-account-button" onClick={() => setDeleteModal(true)}>Verwijderen</button>

                        {/* Een account verwijderen is onomkeerbaar: de
                            inloggegevens zijn daarna definitief weg. Daarom
                            eerst bevestigen. */}
                        <DeleteModal
                            deleteModal={deleteModal}
                            setDeleteModal={setDeleteModal}
                            deleteItem={deleteAccount}
                            deleteName={'je account'}
                        />
                    </div>

                </div>
        </div>
    )
}

export default Profile
